import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContainedButton, OutlinedButton } from '../buttons';
import { FlexRow } from '../content';

// Crop shapes offered by CropImage/CropImageMedia (#1818). The first one is the default; 16:10 is
// the shape every upload had before.
export const CROP_FORMATS = [{
  id: '16:10',
  aspect: 16 / 10,
  labelKey: 'PROVIDER-GALLERY.formatHorizontal',
  label: 'Horizontal'
}, {
  id: '16:9',
  aspect: 16 / 9,
  labelKey: 'PROVIDER-GALLERY.formatWide',
  label: 'Wide'
}, {
  id: '4:3',
  aspect: 4 / 3,
  labelKey: 'PROVIDER-GALLERY.formatClassic',
  label: 'Classic'
}, {
  id: '1:1',
  aspect: 1,
  labelKey: 'PROVIDER-GALLERY.formatSquare',
  label: 'Square'
}, {
  id: '3:4',
  aspect: 3 / 4,
  labelKey: 'PROVIDER-GALLERY.formatVertical',
  label: 'Vertical'
}, {
  id: '9:16',
  aspect: 9 / 16,
  labelKey: 'PROVIDER-GALLERY.formatStory',
  label: 'Story'
}];

// Size rule, on the long side so a vertical crop needs no taller picture than a horizontal one.
// Below the minimum the upload is blocked; below the recommended size the provider is only warned.
export const MIN_LONG_SIDE = 600;
export const RECOMMENDED_LONG_SIDE = 1280;
export const cropSizeStatus = (area, minLongSide = MIN_LONG_SIDE, recommendedLongSide = RECOMMENDED_LONG_SIDE) => {
  if (!area?.width || !area?.height) {
    return null;
  }
  const longSide = Math.max(area.width, area.height);
  return longSide < minLongSide ? 'tooSmall' : longSide < recommendedLongSide ? 'small' : 'ok';
};
const CropFormatPicker = ({
  formats,
  value,
  onChange
}) => {
  const {
    t
  } = useTranslation();
  if (formats.length < 2) {
    return null;
  }
  return /*#__PURE__*/React.createElement(FlexRow, {
    margin: "auto",
    justifyContent: "center",
    flexWrap: "wrap"
  }, formats.map(f => {
    const Button = f.id === value ? ContainedButton : OutlinedButton;
    return /*#__PURE__*/React.createElement(Button, {
      key: f.id,
      color: "primary",
      size: "small",
      onClick: () => onChange(f.id),
      text: `${t(f.labelKey, f.label)} ${f.id}`
    });
  }));
};
export default CropFormatPicker;